module.exports = __webpack_public_path__ + "static/media/tasks.3e1789ca.png";